// extracted by mini-css-extract-plugin
export default {"parallax":"Merch_parallax__X67ZP","container":"Merch_container__cvwzn","wrapperMerch":"Merch_wrapperMerch__pPm1I","box":"Merch_box__K6cn+","photo":"Merch_photo__TzL5H"};